import axiosIns from '@/libs/axios'

const ROOT_URL = '/Apps/dr/dr_statistics'

const emptyStats = () => ({
  diskUsage: {
    usage: 0,
    limit: 0,
    percent: 0,
  },
  userCount: {
    usage: 0,
    limit: 0,
  },
  productCount: {
    usage: 0,
    limit: 0,
  },
  categoryCount: {
    usage: 0,
    limit: 0,
  },
  qrCount: {
    usage: 0,
    limit: 0,
  },
  monthlyVisitAvg: 0,
})

export default {
  namespaced: true,
  state: {
    loading: false,
    dataItem: emptyStats(),
    error: null,
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataItem(state) {
      return state.dataItem
    },
    error(state) {
      return state.error
    },
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_DATA_ITEM(state, data) {
      const base = emptyStats()
      if (!data) {
        state.dataItem = base
        return
      }
      state.dataItem = {
        diskUsage: {
          usage: Number((data.diskUsage && data.diskUsage.usage) || 0),
          limit: Number((data.diskUsage && data.diskUsage.limit) || 0),
          percent: Number((data.diskUsage && data.diskUsage.percent) || 0),
        },
        userCount: {
          usage: Number((data.userCount && data.userCount.usage) || data.userCount || 0),
          limit: Number((data.userCount && data.userCount.limit) || 0),
        },
        productCount: {
          usage: Number((data.productCount && data.productCount.usage) || data.productCount || 0),
          limit: Number((data.productCount && data.productCount.limit) || 0),
        },
        categoryCount: {
          usage: Number((data.categoryCount && data.categoryCount.usage) || data.categoryCount || 0),
          limit: Number((data.categoryCount && data.categoryCount.limit) || 0),
        },
        qrCount: {
          usage: Number((data.qrCount && data.qrCount.usage) || data.qrCount || 0),
          limit: Number((data.qrCount && data.qrCount.limit) || 0),
        },
        monthlyVisitAvg: Number(data.monthlyVisitAvg || 0),
      }
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = emptyStats()
      state.error = null
    },
  },
  actions: {
    getStatistics({ commit }, idLicenses) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      return axiosIns
        .post(ROOT_URL, { id_licenses: idLicenses })
        .then(response => {
          if (response.data.error) {
            commit('SET_ERROR', response.data.error)
            commit('SET_DATA_ITEM', emptyStats())
          } else {
            commit('SET_DATA_ITEM', response.data.data)
          }
          commit('SET_LOADING', false)
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          commit('SET_ERROR', 'İstatistikler alınamadı')
          commit('SET_LOADING', false)
        })
    },
  },
}
